var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRankBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 639,
    height: 259,
    viewBox: "0 0 639 259",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 153.46C0 136.108 11.1869 120.736 27.6974 115.399L145.697 77.2575C171.53 68.9074 198 88.1695 198 115.319V258.352H0V153.46Z",
    fill: "url(#paint0_linear_284_17946)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M441 153.46C441 136.108 452.187 120.736 468.697 115.399L586.697 77.2575C612.53 68.9074 639 88.1695 639 115.319V258.352H441V153.46Z",
    fill: "url(#paint1_linear_284_17946)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197 95.2448C197 77.0471 209.283 61.1428 226.89 56.5435L391.89 13.4415C417.237 6.82034 442 25.9458 442 52.1428V258.352H197V95.2448Z",
    fill: "url(#paint2_linear_284_17946)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M303.02 120.684V105.42H329.612V175.5H312.524V120.684H303.02Z",
    fill: "url(#paint3_linear_284_17946)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4589 182.732C85.9095 181.58 86.5709 181.047 86.4429 181.132C90.6242 177.676 93.9095 174.839 96.2989 172.62C98.7309 170.401 100.779 168.076 102.443 165.644C104.107 163.212 104.939 160.844 104.939 158.54C104.939 156.791 104.534 155.425 103.723 154.444C102.912 153.463 101.696 152.972 100.075 152.972C98.4535 152.972 97.1735 153.591 96.2349 154.828C95.3389 156.023 94.8909 157.729 94.8909 159.948H84.3309C84.4162 156.321 85.1842 153.292 86.6349 150.86C88.1282 148.428 90.0695 146.636 92.4589 145.484C94.8909 144.332 97.5789 143.756 100.523 143.756C105.6 143.756 109.419 145.057 111.979 147.66C114.582 150.263 115.883 153.655 115.883 157.836C115.883 162.401 114.326 166.647 111.211 170.572C108.096 174.455 104.128 178.252 99.3069 181.964H116.587V190.86H84.4589V182.732Z",
    fill: "url(#paint4_linear_284_17946)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M524.663 157.964C524.833 153.399 526.327 149.879 529.143 147.404C531.959 144.929 535.777 143.692 540.599 143.692C543.799 143.692 546.529 144.247 548.791 145.356C551.095 146.465 552.823 147.98 553.975 149.9C555.169 151.82 555.767 153.975 555.767 156.364C555.767 159.18 555.063 161.484 553.655 163.276C552.247 165.025 550.604 166.22 548.727 166.86V167.116C551.159 167.927 553.079 169.271 554.487 171.148C555.895 173.025 556.599 175.436 556.599 178.38C556.599 181.025 555.98 183.372 554.743 185.42C553.548 187.425 551.777 189.004 549.431 190.156C547.127 191.308 544.375 191.884 541.175 191.884C536.055 191.884 531.959 190.625 528.887 188.108C525.857 185.591 524.257 181.793 524.087 176.716H534.711C534.753 178.593 535.287 180.087 536.311 181.196C537.335 182.263 538.828 182.796 540.791 182.796C542.455 182.796 543.735 182.327 544.631 181.388C545.569 180.407 546.039 179.127 546.039 177.548C546.039 175.5 545.377 174.028 544.055 173.132C542.775 172.193 540.705 171.724 537.847 171.724H535.799V162.828H537.847C540.023 162.828 541.772 162.465 543.095 161.74C544.46 160.972 545.143 159.628 545.143 157.708C545.143 156.172 544.716 154.977 543.863 154.124C543.009 153.271 541.836 152.844 540.343 152.844C538.721 152.844 537.505 153.335 536.695 154.316C535.927 155.297 535.479 156.513 535.351 157.964H524.663Z",
    fill: "url(#paint5_linear_284_17946)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_284_17946",
    x1: 99,
    y1: 60.3516,
    x2: 99,
    y2: 258.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0AAFF",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_284_17946",
    x1: 540,
    y1: 60.3516,
    x2: 540,
    y2: 258.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF772A",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_284_17946",
    x1: 319.5,
    y1: 0.351563,
    x2: 319.5,
    y2: 258.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4181FF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_284_17946",
    x1: 318.475,
    y1: 94.8636,
    x2: 318.475,
    y2: 177.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#689AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.570693,
    stopColor: "#689AFF",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979593,
    stopColor: "#689AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_284_17946",
    x1: 100.244,
    y1: 138.409,
    x2: 100.244,
    y2: 193.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#E4B4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#C0A0D2",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C0A0D2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_284_17946",
    x1: 540.774,
    y1: 138.409,
    x2: 540.774,
    y2: 193.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.145,
    stopColor: "#FF772A",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#FF8F24",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9921",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRankBg);
export default __webpack_public_path__ + "static/media/rank_bg.6f775cd05082b0b8fdc974d283bc4422.svg";
export { ForwardRef as ReactComponent };